import { useGetCurrentUserWorkbookAccess } from "@/business/query";
import { useGetMyUser } from "@/user/query";
import { isApOnly, isRep, isTech } from "@/user/utils";

// The API enforces authority independently of product switches. Techs, reps
// and AP-only users cannot manage access, so they skip the poll.
export const useWorkbookAccessEditorAccess = (businessId?: string | null) => {
  const { data: user, isLoading: isUserLoading } = useGetMyUser();
  const mayManage =
    !!user && !isTech(user.role) && !isRep(user.role) && !isApOnly(user.role);
  const enabled = Boolean(businessId) && mayManage;
  const accessQuery = useGetCurrentUserWorkbookAccess(businessId, { enabled });
  return {
    accessQuery,
    canManage: enabled && accessQuery.data?.can_manage_access === true,
    // The nav keeps this query alive, so a page mounting into its cache would
    // otherwise decide from a response up to a refetch interval old. An access
    // gate waits for one fetched after the page itself mounted.
    isAccessLoading:
      isUserLoading ||
      (enabled && !accessQuery.isFetchedAfterMount && !accessQuery.isError),
  };
};
